type StatusPillProps = {
  text: string;
  theme?: 'indigo' | 'purple' | 'blue' | 'green' | 'gradient';
  animated?: boolean;
  className?: string;
};

export function StatusPill({
  text,
  theme = 'indigo',
  animated = false,
  className = '',
}: StatusPillProps) {
  const themes = {
    indigo: {
      bg: 'bg-indigo-100',
      text: 'text-indigo-700',
      dot: 'bg-indigo-500',
    },
    purple: {
      bg: 'bg-purple-100',
      text: 'text-purple-700',
      dot: 'bg-purple-500',
    },
    blue: {
      bg: 'bg-blue-100',
      text: 'text-blue-700',
      dot: 'bg-blue-500',
    },
    green: {
      bg: 'bg-green-100',
      text: 'text-green-700',
      dot: 'bg-green-500',
    },
    gradient: {
      bg: 'bg-gradient-to-r from-indigo-100 to-purple-100',
      text: 'text-indigo-700',
      dot: 'bg-indigo-500',
    },
  };

  const { bg, text: textColor, dot } = themes[theme];

  return (
    <div
      class={`inline-flex items-center gap-2 ${bg} ${textColor} text-sm font-medium px-3 py-1 rounded-full ${className}`}
    >
      <div class={`w-2 h-2 ${dot} rounded-full ${animated ? 'animate-pulse' : ''}`} />
      {text}
    </div>
  );
}
